import styled from "styled-components";

import FnrShineButton from "../FnrShineButton";

export default function SectionTabButton({
  icon,
  title,
  itemKey,
  setSelectedItem,
  selectedItem,
  highlightColor,
}) {
  return (
    <Wrapper>
      <FnrShineButton borderRadius={8} shineColor={highlightColor}>
        <Inside>
          <Icon className={icon} />
          <Title>{title}</Title>
        </Inside>
      </FnrShineButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: var(--tabButtonWidth);
  flex-grow: 0;
  flex-shrink: 0;
`;
const Inside = styled.div`
  text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px;
`;
const Icon = styled.div`
  font-size: 28px;
`;
const Title = styled.div`
  font-size: 13px;
  text-align: center;
  line-height: 15px;
`;
